import type { components } from '@slims-pro/api-client';
import { useQuery } from '@tanstack/react-query';
import { ApiError, api } from '@/lib/api';
import { fetchAllPages } from '@/lib/paginate';

export type PlantKind = components['schemas']['PlantKind'];

/** Every plant (all pages), so fleet cards and header selects see the whole list. */
export function usePlants({ kind }: { kind?: PlantKind } = {}) {
	return useQuery({
		queryKey: ['plants', { kind }],
		queryFn: async () => {
			const items = await fetchAllPages(async (cursor) => {
				const { data, response } = await api.GET('/api/v1/plants', {
					params: { query: { kind, limit: 500, cursor } },
				});
				if (!data) throw new ApiError(response.status, '/api/v1/plants');
				return data;
			});
			return { items };
		},
	});
}
